// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_y9L","cls2":"CoauthorConfirmationCard-cls2_yZ1 CoauthorConfirmationCard-cls1_y9L"};